import GridRows from '../../grid/rows';
import InlineEditors from '../../controllers/inlineEditors';

export default instance => {
  instance.attachEvent('onTaskDblClick', (id, event) => {
    const masschangeEnable = instance.ganttDataApi.isMassChangeEnabled();

    if (InlineEditors.isActive() && !masschangeEnable) {
      InlineEditors.onClick();
    }

    if (!InlineEditors.isActive() && !masschangeEnable) {
      GridRows.onTaskDblClick(id, event);
    }
  });
};
